import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {memoize} from 'decko';
import {saveAs} from 'file-saver/FileSaver';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {DataChangesObserver, TitleService} from '@common-lib';

import {ConfigurationService} from '../../pages-services';
import {ConfigurationBaseComponent} from '../configuration-base/configuration-base.component';

@Component({
    selector: 'app-configuration-products',
    templateUrl: './configuration-products.component.html',
    styleUrls: ['../configuration-base/configuration-base.component.scss', '../configuration-products/configuration-products.component.scss'],
})

export class ConfigurationProductsComponent extends ConfigurationBaseComponent implements OnInit {
    resource = 'product';

    navigations = [];
    products = [];
    productsToExport: any[] = [];

    constructor(
        protected title: TitleService,
        protected route: ActivatedRoute,
        protected toasterService: ToasterService,
        protected dataChanges: DataChangesObserver,
        protected translateService: TranslateService,
        protected configurationService: ConfigurationService
    ) {
        super(title, route, toasterService, dataChanges, translateService, configurationService);
    }

    ngOnInit() {
        this.configurationService.getList('navigations', this.selectedLocale).subscribe(({result}) => {
            this.navigations = this.createChangesObservation(result);
        });

        this.loadItems();
    }

    protected loadItems(): Promise<Object> {
        const resource = 'products';
        return new Promise((resolve, reject) => {
            this.configurationService.getList(resource, this.selectedLocale).subscribe(({result}) => {
                this.state.productsById = {};
                result.products.forEach(product => this.state.productsById[product.id] = product.title);
                this.state.items = this.createChangesObservation(result.products);
                resolve(this.state.items);
            }, error => reject(error));
        });
    }

    @memoize()
    getDropdownList(productId) {
        return this.navigations.filter(item => item.productId === productId || !item.productId);
    }

    dropdownOnAdd(event, productId) {
        const {id} = event;
        this.navigations.forEach(item => {
            if (item.id === id) {
                item.productId = productId;
            }
        });
    }

    dropdownOnRemove(event) {
        const {id} = event.value;
        this.navigations.forEach(item => {
            if (item.id === id) {
                delete item.productId;
            }
        });
    }

    toggleItem({target}, itemIndex, itemId?: string) {
        super.toggleItem({target}, itemIndex);

        target.checked
            ? this.productsToExport.push(itemId)
            : this.productsToExport.splice(this.productsToExport.indexOf(itemId), 1);
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/configuration-products/configuration-products.component.ts